<template>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">ERP/Accounting</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div>
              <h2>Login Credentials</h2>
            </div>
            <div class="mt-3 mw-500px">
              <label class="fw-bold" for="erp_type">
                ERP Type
                <span class="text-danger ms-2">*</span>
              </label>
              <multiselect
                v-model="form.erp_type"
                :options="erpOptions"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select ERP Type"
                track-by="value"
                label="label"
                :disabled="checkErpTypeDisabled()"
              ></multiselect>
              <span class="is-invalid" v-if="fieldRequired.isErpTypeRequired"
                >The field is required.</span
              >
            </div>

            <!-- Virgo Fields -->
            <template v-if="form.erp_type === 1">
              <div class="mt-3 mw-500px">
                <label class="fw-bold" for>
                  ERP's Api End Point
                  <span class="text-danger ms-2">*</span>
                </label>
                <material-input
                  v-model="form.api_end_point"
                  type="text"
                  id="api_end_point"
                  name="api_end_point"
                />
                <span class="is-invalid" v-if="fieldRequired.isApiEndPointRequired"
                  >The field is required.</span
                >
              </div>
              <div class="mt-3 mw-500px">
                <label class="fw-bold" for>
                  Company Code
                  <span class="text-danger ms-2">*</span>
                </label>
                <material-input
                  v-model="form.company_code"
                  type="text"
                  id="company_code"
                  name="company_code"
                />
                <span class="is-invalid" v-if="fieldRequired.isCompanyCodeRequired"
                  >The field is required.</span
                >
              </div>
              <div class="mt-3 mw-500px">
                <label class="fw-bold" for>
                  Client Code
                  <span class="text-danger ms-2">*</span>
                </label>
                <material-input
                  v-model="form.client_code"
                  type="text"
                  id="client_code"
                  name="client_code"
                />
                <span class="is-invalid" v-if="fieldRequired.isClientCodeRequired"
                  >The field is required.</span
                >
              </div>
            </template>

            <!-- Xero/QuickBooks Fields -->
            <template v-if="form.erp_type === 2 || form.erp_type === 3">
              <div class="mt-3 mw-500px">
                <label class="fw-bold" for>
                  Client ID
                  <span class="text-danger ms-2">*</span>
                </label>
                <material-input
                  v-model="form.client_id"
                  type="text"
                  id="client_id"
                  name="erp_client_id"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                />
                <span class="is-invalid" v-if="fieldRequired.isClientIdRequired"
                  >The field is required.</span
                >
              </div>
              <div class="mt-3 mw-500px">
                <label class="fw-bold" for>
                  Client Secret
                  <span class="text-danger ms-2">*</span>
                </label>
                <material-input
                  v-model="form.client_secret"
                  type="text"
                  id="client_secret"
                  name="erp_client_secret"
                  autocomplete="new-password"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                />
                <span class="is-invalid" v-if="fieldRequired.isClientSecretRequired"
                  >The field is required.</span
                >
              </div>
            </template>

            <material-button
              class="btn btn-sm btn-background mt-3"
              @click="saveLoginCredentials()"
            >
              Save and login
            </material-button>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title
          date
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import AnalyticsService from "../../services/analytics.service";
import Multiselect from "@vueform/multiselect";
import { scrollToFirstInvalid } from "@/config/utils";

export default {
  name: "login-credentials",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    MaterialInput,
    Multiselect
  },
  data() {
    return {
      message: "",
      snackbar: null,
      loaderActive: false,
      erpOptions: [
        { value: 1, label: 'Virgo' },
        { value: 2, label: 'Xero' },
        { value: 3, label: 'QuickBooks' }
      ],
      form: {
        api_end_point: "",
        company_code: "",
        client_code: "",
        token: "",
        authentication: "",
        erp_type: 0,
        client_id: "",
        client_secret: "",
      },
      serviceUploadType: 0,
      fieldRequired: {},
    };
  },
  created() {
    this.getLoginCredentials();
    if (this.$route.query.loginXero == 1) {
      this.snackbar = "success";
      this.message = "Login Xero Success";
      this.setTimeOutNotification();
    }

    if (this.$route.query.loginQbo == 1) {
      this.snackbar = "success";
      this.message = "Login QuickBooks Success";
      this.setTimeOutNotification();
    }
  },
  methods: {
    checkErpTypeDisabled() {
      // Just enable when checked erp type is not 0 and is not the same as the current type
      return this.serviceUploadType !== 0 && this.serviceUploadType == this.form.erp_type;
    },
    getLoginCredentials() {
      this.showLoader();

      AnalyticsService.getLoginCredentials().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.form = response.data.data;
            this.serviceUploadType = parseInt(response.data.data.service_upload_type);
            this.form.erp_type = this.serviceUploadType !== 0 ? this.serviceUploadType : 0;

            if (this.form.erp_type === 2) {
              this.form.client_id = response.data.data.xero_client_id;
              this.form.client_secret = response.data.data.xero_client_secret;
            }

            if (this.form.erp_type === 3) {
              this.form.client_id = response.data.data.qbo_client_id;
              this.form.client_secret = response.data.data.qbo_client_secret;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    saveLoginCredentials() {
      if (this.processValidate()) {
        this.showLoader();

        if (this.form.erp_type === 1) { // Virgo
          AnalyticsService.saveLoginCredentials(this.form).then(
            (response) => {
              if (response.data.result.isSuccess) {
                this.snackbar = "success";
                this.message = "Save Virgo Login Credentials Success";
                this.setTimeOutNotification();
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        } else if (this.form.erp_type === 2) { // Xero
          AnalyticsService.saveXeroLoginCredentials(this.form).then(
            (response) => {
              if (response.data.result.isSuccess) {
                window.location.href = response.data.data.url;
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        } else if (this.form.erp_type === 3) { // QuickBooks
          AnalyticsService.saveQuickbooksLoginCredentials(this.form).then(
            (response) => {
              if (response.data.result.isSuccess) {
                window.location.href = response.data.data.url;
              } else {
                this.snackbar = "danger";
                this.message = response.data.result.message;
                this.setTimeOutNotification();
              }
              this.hideLoader();
            },
            (error) => {
              this.snackbar = "danger";
              this.message = error;
              this.hideLoader();
              this.setTimeOutNotification();
            }
          );
        }
      }
    },

    resetRequired() {
      this.fieldRequired.isApiEndPointRequired = false;
      this.fieldRequired.isCompanyCodeRequired = false;
      this.fieldRequired.isClientCodeRequired = false;
      this.fieldRequired.isErpTypeRequired = false;
      this.fieldRequired.isClientIdRequired = false;
      this.fieldRequired.isClientSecretRequired = false;
    },

    processValidate() {
      this.resetRequired();
      var isValid = true;

      if (this.form.erp_type == "" || this.form.erp_type == null) {
        this.fieldRequired.isErpTypeRequired = true;
        isValid = false;
      }

      if (this.form.erp_type === 1 && (this.form.api_end_point == "" || this.form.api_end_point == null)) {
        this.fieldRequired.isApiEndPointRequired = true;
        isValid = false;
      }

      if (this.form.erp_type === 1 && (this.form.company_code == "" || this.form.company_code == null)) {
        this.fieldRequired.isCompanyCodeRequired = true;
        isValid = false;
      }

      if (this.form.erp_type === 1 && (this.form.client_code == "" || this.form.client_code == null)) {
        this.fieldRequired.isClientCodeRequired = true;
        isValid = false;
      }

      if ((this.form.erp_type === 2 || this.form.erp_type === 3) && (this.form.client_id == "" || this.form.client_id == null)) {
        this.fieldRequired.isClientIdRequired = true;
        isValid = false;
      }

      if ((this.form.erp_type === 2 || this.form.erp_type === 3) && (this.form.client_secret == "" || this.form.client_secret == null)) {
        this.fieldRequired.isClientSecretRequired = true;
        isValid = false;
      }

      if (!isValid) {
        scrollToFirstInvalid();
      }

      return isValid;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.mw-500px {
  max-width: 500px !important;
}
</style>
